exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._32bm-T5DQoIySKv_IZhm9h{font-size:11px}html[dir] ._1Lles4GZRSd49mVG8_cS8E{background-color:unset!important}", ""]);
// Exports
exports.locals = {
	"roomSecondaryText": "_32bm-T5DQoIySKv_IZhm9h",
	"roomSecondaryCapabilityIcon": "_1Lles4GZRSd49mVG8_cS8E"
};